import styled from "styled-components";
const COIssueType = ({ type, themeColor, inverted, annotation }) => {
  return (
    <Div themeColor={themeColor} inverted={inverted}>
      <div className="ftaType">{type}</div>
      <div className="until">{annotation}</div>
    </Div>
  );
};
export default COIssueType;
const Div = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  & > div {
    &.ftaType {
      /* 원색 통짜 뱃지 대신 은은한 배경 + 상태색 글자 */
      border-radius: 999px;
      background-color: ${({ theme, themeColor }) =>
        themeColor === "safe"
          ? theme.colors.background.lightgreen
          : themeColor === "caution"
          ? theme.colors.background.lightyellow
          : theme.colors.monotone.extralight};
      color: ${({ theme, themeColor }) =>
        themeColor ? theme.colors[themeColor] : theme.colors.foreground.dimmed};
      font-size: 0.8em;
      font-weight: 700;
      padding: 0.35em 0.8em;
    }
    &.until {
      position: absolute;
      bottom: 1em;
      font-size: .8em;
      left: 2.9em;
    }
  }
`;
